var _excluded = ["desc", "focusable", "title", "iconName", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { string, bool } from 'prop-types';
import classNames from 'classnames';
var svg = /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.511 8.519l1.964 1.964L24 8.959V6.994h-1.964zM15.87 25a3.054 3.054 0 01-2.134-.863 3.132 3.132 0 01-.969-2.281.464.464 0 01.928-.013v.013a2.2 2.2 0 00.68 1.6 2.178 2.178 0 001.615.601 2.305 2.305 0 002.06-2.353v-.708a1.515 1.515 0 01.711-1.305 5.81 5.81 0 002.76-5.756 5.688 5.688 0 00-11.112-.861.465.465 0 01-.576.317h-.001a.47.47 0 01-.313-.584 6.614 6.614 0 0112.923 1.005 6.752 6.752 0 01-3.21 6.689.569.569 0 00-.254.496v.707a3.248 3.248 0 01-2.939 3.292 2.775 2.775 0 01-.169.004zm3.054-8.024a.464.464 0 01-.235-.064.473.473 0 01-.165-.644 3.06 3.06 0 00.379-1.982 3.107 3.107 0 00-2.704-2.642 3.027 3.027 0 00-3.258 2.192.465.465 0 01-.576.317.47.47 0 01-.313-.584 3.993 3.993 0 117.273 3.176.463.463 0 01-.4.231zm6.019 4.02h-1.287V25h-1v-4.004h-1.285v-.879h3.572zm-9.16-3.82l-1.964-1.965-6.814 6.814v1.965h1.964z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 3A13 13 0 113 16 13 13 0 0116 3m0-1a14 14 0 1014 14A14 14 0 0016 2z"
}));

var Icon = function Icon(_ref) {
  var desc = _ref.desc,
      _ref$focusable = _ref.focusable,
      focusable = _ref$focusable === void 0 ? false : _ref$focusable,
      title = _ref.title,
      iconName = _ref.iconName,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: String(focusable),
    className: classNames('rds-svg--hearing-induction-loop-circle-icon', className)
  }, rest, svg.props), title && /*#__PURE__*/React.createElement("title", null, title), desc && /*#__PURE__*/React.createElement("desc", null, desc), svg.props.children);
};

Icon.propTypes = {
  desc: string,
  focusable: bool,
  title: string,
  iconName: string,
  className: string
};
Icon.displayName = 'HearingInductionLoopCircleIcon';
export default Icon;